import { render, staticRenderFns } from "./LaboratoryPartners.vue?vue&type=template&id=c38b1c18&scoped=true"
import script from "./LaboratoryPartners.vue?vue&type=script&lang=js"
export * from "./LaboratoryPartners.vue?vue&type=script&lang=js"
import style0 from "./LaboratoryPartners.vue?vue&type=style&index=0&id=c38b1c18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38b1c18",
  null
  
)

export default component.exports